import { Alert, Table } from "flowbite-react";
import TitleStripe from "../TitleStripe";
import NoOcurrence from "./NoOcurrence";
import { formatToReal } from "../../../utils/utils";
import moment from "moment";
import AvisoCard from "./AvisoCard";
import ParticipacaoEmEmpresas from "./ParticipacaoEmEmpresas";
import { EvaluationScore } from "./EvaluationScore";
import ChequesSustados from "./ChequesSustados";
import ChequesSemFundos from "./ChequesSemFundos";
import Protestos from "./Protestos";
import ReactApexChart from "react-apexcharts";
import AcoesCiveis from "./AcoesCiveis";
import PendenciasFinanceiras from "./PendenciasFinanceiras";
import HistoricoConsultas from "./HistoricoConsultas";

const AvaliaRiscoPF = ({ data }) => {
  return (
    <>
      {data?.statusRetorno == 1 ? (
        <>
          {data?.consultaCredito?.dadosCadastrais && (
            <div className="mt-6 border rounded-2xl shadow p-6 bg-white">
              <h3 className="text-lg font-bold mb-4 border-b pb-2">
                📄 Dados Cadastrais
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700">
                <div>
                  <div className="mb-2">
                    <strong>Nome completo:</strong>{" "}
                    {data.consultaCredito.dadosCadastrais.nome ||
                      "Indisponível"}
                  </div>
                  <div className="mb-2 flex flex-wrap items-center gap-2">
                    <strong>Data de nascimento:</strong>{" "}
                    {data.consultaCredito.dadosCadastrais.dataNascimento ||
                      "Indisponível"}
                    {data.consultaCredito.dadosCadastrais.dataNascimento && (
                      <span className="bg-primary text-white px-2 py-0.5 rounded-md text-xs font-semibold">
                        {moment().diff(
                          moment(
                            data.consultaCredito.dadosCadastrais.dataNascimento,
                            "DD/MM/YYYY"
                          ),
                          "years"
                        )}{" "}
                        anos
                      </span>
                    )}
                  </div>
                  <div className="mb-2">
                    <strong>Sexo:</strong>{" "}
                    {data.consultaCredito.dadosCadastrais.sexo ||
                      "Indisponível"}
                  </div>
                  <div className="mb-2">
                    <strong>Endereço:</strong>{" "}
                    {data.consultaCredito.dadosCadastrais.endereco ||
                      "Indisponível"}
                  </div>
                  <div className="mb-2">
                    <strong>Cidade:</strong>{" "}
                    {data.consultaCredito.dadosCadastrais.cidade ||
                      "Indisponível"}
                  </div>
                </div>

                <div>
                  <div className="mb-2">
                    <strong>CPF:</strong>{" "}
                    {data.consultaCredito.dadosCadastrais.cpf || "Indisponível"}
                  </div>
                  <div className="mb-2">
                    <strong>Nome da mãe:</strong>{" "}
                    {data.consultaCredito.dadosCadastrais.nomeMae ||
                      "Indisponível"}
                  </div>
                  <div className="mb-2">
                    <strong>Bairro:</strong>{" "}
                    {data.consultaCredito.dadosCadastrais.bairro ||
                      "Indisponível"}
                  </div>
                  <div className="mb-2">
                    <strong>CEP:</strong>{" "}
                    {data.consultaCredito.dadosCadastrais.cep || "Indisponível"}
                  </div>
                </div>
              </div>
            </div>
          )}

          <div>
            <TitleStripe className="mb-5">Participação Societária</TitleStripe>
            {data?.consultaCredito?.participacaoEmEmpresas?.length > 0 ? (
              <ParticipacaoEmEmpresas
                empresas={data?.consultaCredito?.participacaoEmEmpresas}
              />
            ) : (
              <NoOcurrence />
            )}
          </div>

          {data?.consultaCredito?.faturasEmAtraso?.NOTA && (
            <div>
              <TitleStripe className="mb-5">Faturas em atraso</TitleStripe>
              <div className="-mt-2 mb-2 text-sm">
                Indica uma nota para o máximo de dias que 1 fatura ficou em
                atraso nos últimos 6 meses.
              </div>

              <div className="border border-gray-300 grid grid-cols-5 rounded-md overflow-hidden">
                <div
                  className={`${
                    data?.consultaCredito?.faturasEmAtraso?.NOTA === "A"
                      ? "border-4 border-blue-500"
                      : "border-gray-300 border"
                  } p-2 text-center font-bold text-lg bg-green-200`}
                  style={{ color: "#1B914E" }}
                >
                  A
                </div>
                <div
                  className={`${
                    data?.consultaCredito?.faturasEmAtraso?.NOTA === "B"
                      ? "border-4 border-blue-500"
                      : "border-gray-300 border"
                  } p-2 text-center font-bold text-lg bg-green-100`}
                  style={{ color: "#73CC37" }}
                >
                  B
                </div>
                <div
                  className={`${
                    data?.consultaCredito?.faturasEmAtraso?.NOTA === "C"
                      ? "border-4 border-blue-500"
                      : "border-gray-300 border"
                  } p-2 text-center font-bold text-lg bg-yellow-100`}
                  style={{ color: "#F9C920" }}
                >
                  C
                </div>
                <div
                  className={`${
                    data?.consultaCredito?.faturasEmAtraso?.NOTA === "D"
                      ? "border-4 border-blue-500"
                      : "border-gray-300 border"
                  } p-2 text-center font-bold text-lg bg-orange-100`}
                  style={{ color: "#F4771E" }}
                >
                  D
                </div>
                <div
                  className={`${
                    data?.consultaCredito?.faturasEmAtraso?.NOTA === "E"
                      ? "border-4 border-blue-500"
                      : "border-gray-300 border"
                  } p-2 text-center font-bold text-lg bg-red-100`}
                  style={{ color: "#F23829" }}
                >
                  E
                </div>
              </div>
              <div className="mt-2 text-sm">
                Quanto mais próximo o consumidor estiver da faixa{" "}
                <span className="font-semibold">A</span>, menos dias a fatura
                está ou ficou em atraso e quanto mais próximo da faixa{" "}
                <span className="font-semibold">E</span>, mais dias a fatura
                ficou em atraso.
              </div>
            </div>
          )}

          {data?.consultaCredito?.contratosRecentes?.NOTA && (
            <div>
              <TitleStripe className="mb-5">Contratos recentes</TitleStripe>
              <div className="-mt-2 mb-2 text-sm">
                Indica uma nota para o nível de comprometimento de crédito do
                consumidor, com base na quantidade de contratos fechados nos
                últimos 6 meses.
              </div>

              <div className="border border-gray-300 grid grid-cols-5 rounded-md overflow-hidden">
                <div
                  className={`${
                    data?.consultaCredito?.contratosRecentes?.NOTA === "A"
                      ? "border-4 border-blue-500"
                      : "border-gray-300 border"
                  } p-2 text-center font-bold text-lg bg-green-200`}
                  style={{ color: "#1B914E" }}
                >
                  A
                </div>
                <div
                  className={`${
                    data?.consultaCredito?.contratosRecentes?.NOTA === "B"
                      ? "border-4 border-blue-500"
                      : "border-gray-300 border"
                  } p-2 text-center font-bold text-lg bg-green-100`}
                  style={{ color: "#73CC37" }}
                >
                  B
                </div>
                <div
                  className={`${
                    data?.consultaCredito?.contratosRecentes?.NOTA === "C"
                      ? "border-4 border-blue-500"
                      : "border-gray-300 border"
                  } p-2 text-center font-bold text-lg bg-yellow-100`}
                  style={{ color: "#F9C920" }}
                >
                  C
                </div>
                <div
                  className={`${
                    data?.consultaCredito?.contratosRecentes?.NOTA === "D"
                      ? "border-4 border-blue-500"
                      : "border-gray-300 border"
                  } p-2 text-center font-bold text-lg bg-orange-100`}
                  style={{ color: "#F4771E" }}
                >
                  D
                </div>
                <div
                  className={`${
                    data?.consultaCredito?.contratosRecentes?.NOTA === "E"
                      ? "border-4 border-blue-500"
                      : "border-gray-300 border"
                  } p-2 text-center font-bold text-lg bg-red-100`}
                  style={{ color: "#F23829" }}
                >
                  E
                </div>
              </div>
              <div className="mt-2 text-sm">
                Quanto mais próximo da faixa{" "}
                <span className="font-semibold">A</span>, menos contratos foram
                fechados e quanto mais perto da faixa{" "}
                <span className="font-semibold">E</span>, mais contratos foram
                fechados nos últimos 6 meses.
              </div>
            </div>
          )}

          <div>
            <TitleStripe className="mb-5">Histórico de consultas</TitleStripe>

            {data?.consultaCredito?.historicoConsultas?.length > 0 ? (
              <div>
                <div className="flex gap-2 items-start">
                  {data?.consultaCredito?.historicoConsultasResumo
                    ?.paresMesAnoHistoricoConsultas?.length > 0 && (
                    <ReactApexChart
                      className="border border-gray-200 rounded-md w-full mt-3"
                      options={{
                        chart: {
                          height: 150,
                          type: "bar",
                          toolbar: {
                            show: false, // Remove o menu de ações
                          },
                        },
                        plotOptions: {
                          bar: {
                            borderRadius: 2,
                            dataLabels: {
                              position: "center", // top, center, bottom
                            },
                          },
                        },
                        dataLabels: {
                          enabled: true,
                          formatter: function (val) {
                            return val;
                          },
                          offsetY: 0,
                          style: {
                            fontSize: "12px",
                            colors: ["white"],
                          },
                        },

                        xaxis: {
                          categories:
                            data?.consultaCredito?.historicoConsultasResumo
                              ?.paresMesAnoHistoricoConsultas,
                          position: "top",
                          axisBorder: {
                            show: false,
                          },
                          axisTicks: {
                            show: false,
                          },
                          crosshairs: {
                            fill: {
                              type: "gradient",
                              gradient: {
                                colorFrom: "#309ADB",
                                colorTo: "#309ADB",
                                stops: [0, 100],
                                opacityFrom: 0.4,
                                opacityTo: 0.5,
                              },
                            },
                          },
                          tooltip: {
                            enabled: true,
                          },
                        },
                        yaxis: {
                          axisBorder: {
                            show: false,
                          },
                          axisTicks: {
                            show: false,
                          },
                          labels: {
                            show: false,
                            formatter: function (val) {
                              return val;
                            },
                          },
                        },
                        title: {
                          text: "Últimos 90 dias",
                          floating: true,
                          offsetY: 155,
                          align: "center",
                          style: {
                            color: "#444",
                          },
                        },
                      }}
                      series={[
                        {
                          name: "Qtd. Consultas no período",
                          data: data?.consultaCredito?.historicoConsultasResumo
                            ?.totaisHistoricoConsultas,
                        },
                      ]}
                      type="bar"
                      height={175}
                    />
                  )}
                </div>
                <HistoricoConsultas
                  historicoConsultas={data?.consultaCredito?.historicoConsultas}
                />
              </div>
            ) : (
              <NoOcurrence />
            )}
          </div>

          <TitleStripe>Quadro de avisos</TitleStripe>
          <div className="container-alerts three-columns">
            <AvisoCard
              title="Negativações"
              hasRestrictions={
                +data?.consultaCredito?.resumoConsulta?.pendenciasFinanceiras
                  ?.quantidadeTotal > 0 ||
                data?.consultaCredito?.resumoConsulta?.pendenciasFinanceiras
                  ?.valorTotal != "0"
              }
              messageError={`${data?.consultaCredito?.resumoConsulta?.pendenciasFinanceiras?.quantidadeTotal} ocorrências`}
            />

            <AvisoCard
              title="Cheques Sustados"
              hasRestrictions={
                +data?.consultaCredito?.resumoConsulta?.chequesSustados
                  ?.quantidadeTotal > 0
              }
              messageError={`${data?.consultaCredito?.resumoConsulta?.chequesSustados?.quantidadeTotal}
                      ocorrências`}
            />

            <AvisoCard
              title="Cheques sem Fundos"
              hasRestrictions={
                +data?.consultaCredito?.resumoConsulta?.chequesSemFundo
                  ?.quantidadeTotal > 0
              }
              messageError={`${data?.consultaCredito?.resumoConsulta?.chequesSemFundo?.quantidadeTotal}
                      ocorrências`}
            />

            <AvisoCard
              title="Protestos"
              hasRestrictions={
                +data?.consultaCredito?.resumoConsulta?.protestos
                  ?.quantidadeTotal > 0
              }
              messageError={`${data?.consultaCredito?.resumoConsulta?.protestos?.quantidadeTotal} ocorrências`}
            />

            <AvisoCard
              title="Ações Cíveis"
              hasRestrictions={
                +data?.consultaCredito?.resumoConsulta?.acoesCiveis
                  ?.quantidadeTotal > 0
              }
              messageError={`${data?.consultaCredito?.resumoConsulta?.acoesCiveis?.quantidadeTotal} ocorrências`}
            />
          </div>

          <EvaluationScore
            data={data}
            score={data?.consultaCredito?.score?.score}
            probability={data?.consultaCredito?.score?.probabilidade}
          />

          <div>
            <TitleStripe className="mb-5">Negativações</TitleStripe>

            {data?.consultaCredito?.pendenciasFinanceiras?.length > 0 ? (
              <>
                <PendenciasFinanceiras
                  quantidadeTotal={
                    data?.consultaCredito?.resumoConsulta?.pendenciasFinanceiras
                      ?.quantidadeTotal
                  }
                  valorTotal={
                    data?.consultaCredito?.resumoConsulta?.pendenciasFinanceiras
                      ?.valorTotal
                  }
                  pendenciasFinanceiras={
                    data?.consultaCredito?.pendenciasFinanceiras
                  }
                />
              </>
            ) : (
              <NoOcurrence />
            )}

            <div>
              <TitleStripe className="mb-5">Cheques sustados</TitleStripe>

              {data?.consultaCredito?.chequesSustados?.length > 0 ? (
                <>
                  <ChequesSustados
                    chequesSustados={data?.consultaCredito?.chequesSustados}
                  />
                </>
              ) : (
                <NoOcurrence />
              )}
            </div>
            <div>
              <TitleStripe className="mb-5">Cheques sem fundos</TitleStripe>

              {data?.consultaCredito?.chequesSemFundo?.length > 0 ? (
                <>
                  <ChequesSemFundos
                    chequesSemFundos={data?.consultaCredito?.chequesSemFundo}
                  />
                </>
              ) : (
                <NoOcurrence />
              )}
            </div>

            <div>
              <TitleStripe className="mb-5">Títulos protestados</TitleStripe>
              {data?.consultaCredito?.protestos?.length > 0 ? (
                <Protestos
                  quantidadeTotal={
                    data?.consultaCredito?.resumoConsulta?.protestos
                      ?.quantidadeTotal
                  }
                  valorTotal={
                    data?.consultaCredito?.resumoConsulta?.protestos?.valorTotal
                  }
                  protestos={data?.consultaCredito?.protestos}
                />
              ) : (
                <NoOcurrence />
              )}
            </div>
          </div>

          <div>
            <TitleStripe className="mb-5">Ações cíveis</TitleStripe>
            {data?.consultaCredito?.acoesCiveis?.length > 0 ? (
              <AcoesCiveis
                quantidadeTotal={
                  data?.consultaCredito?.resumoConsulta?.acoesCiveis
                    ?.quantidadeTotal
                }
                acoesCiveis={data?.consultaCredito?.acoesCiveis}
              />
            ) : (
              <NoOcurrence />
            )}
          </div>
        </>
      ) : (
        <>
          <TitleStripe>Avalia Risco PF</TitleStripe>
          <Alert className="mt-2" color="gray" withBorderAccent>
            Consulta indisponível no momento!
          </Alert>
        </>
      )}
    </>
  );
};

export default AvaliaRiscoPF;
